import React, { useEffect, useRef } from 'react';
import hljs from 'highlight.js';

const CodeHighlight = ({ code }) => {
    const codeRef = useRef(null);

    useEffect(() => {
        if (codeRef.current) {
            codeRef.current.removeAttribute('data-highlighted');
            hljs.highlightElement(codeRef.current);
            if (window.hljs && window.hljs.lineNumbersBlock) {
                window.hljs.lineNumbersBlock(codeRef.current);
            }
        }
    }, [code]);

    return (
        <pre className="code-pre">
            <code
                className="fontFamily"
                ref={codeRef}
            >
                {code}
            </code>
        </pre>
    );
};

export default CodeHighlight;
